<template>
  <div>
    <v-row class="text-center mx-5">
      <v-col v-for="(stats, index) in clientStats" :key="index" md="3" cols="6">
        <v-card>
          <v-card-text>
            <h5>{{ stats.name }}</h5>
            <h5
              v-if="Object.keys(stats).includes('amount')"
              class="font-6 grey--text"
            >
              NRs. {{ stats.amount || 0 }}
            </h5>
            <h5 class="font-6 grey--text">
              <span v-if="![0, 1, 2].includes(index)">
                {{ stats.data || "N/A" }}
              </span>
              <span v-else> ({{ stats.data || "N/A" }}) </span>
            </h5>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-5">
      <v-col md="6">
        <div class="d-flex">
          <span class="text-left mb-1">Basic Information</span>
          <v-spacer></v-spacer>
          <div class="text-right">
            <a
              class="link font-weight-bold subtitle-2 blue--text"
              @click="clientDetail && (clientForm = true)"
            >
              Edit
            </a>
          </div>
        </div>
        <v-card class="mb-2">
          <v-card-text>
            <client-basic-information
              :client-detail.sync="clientDetail"
            ></client-basic-information>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="6">
        <div class="d-flex">
          <span class="text-left mb-1">Contact Information</span>
          <v-spacer></v-spacer>
          <div class="text-right">
            <a
              class="link font-weight-bold subtitle-2 blue--text"
              @click="clientContactNumberForm = true"
            >
              Add New
            </a>
          </div>
        </div>
        <v-card class="mb-2">
          <v-card-text>
            <client-contact-numbers
              :client-contact-number-form="clientContactNumberForm"
              :contact-number-form.sync="clientContactNumberForm"
              :client-slug="clientDetail.slug"
            ></client-contact-numbers>
          </v-card-text>
        </v-card>
        <div class="d-flex mt-4">
          <span class="font-2 text-left mb-1">Social Links</span>
          <v-spacer></v-spacer>
          <div class="text-right">
            <a
              class="link font-weight-bold subtitle-2 blue--text"
              @click="clientSocialLinkForm = true"
            >
              Add New
            </a>
          </div>
        </div>
        <v-card class="mb-2">
          <v-card-text>
            <client-social-link
              :client-social-link-form="clientSocialLinkForm"
              :social-link-form.sync="clientSocialLinkForm"
              :client-slug="clientDetail.slug"
            ></client-social-link>
          </v-card-text>
        </v-card>
        <div class="d-flex mt-4">
          <span class="font-2 text-left mb-1">Assigned Users</span>
          <v-spacer></v-spacer>
          <div class="text-right">
            <a
              class="link font-weight-bold subtitle-2 blue--text"
              @click="clientAssignedUserForm = true"
            >
              Add New
            </a>
          </div>
        </div>
        <v-card>
          <v-card-text>
            <client-assigned-users
              :client-assigned-user-form="clientAssignedUserForm"
              :assigned-user-form.sync="clientAssignedUserForm"
              :client-slug="clientDetail.slug"
            ></client-assigned-users>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col md="7">
        <client-activity></client-activity>
      </v-col> -->
    </v-row>
    <!-- Client Form --><v-navigation-drawer
      width="900"
      v-model="clientForm"
      right
      temporary
      fixed
      clipped
    >
      <template v-slot:prepend>
        <v-card tile>
          <vue-card-title
            :title="'Update Client'"
            dark
            :subtitle="'Fill up the following form to action on client data.'"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="clientForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
        </v-card>
      </template>
      <client-form
        v-if="clientDetail && clientForm"
        :action-data.sync="clientDetail"
        :client-type="clientDetail.client_type"
        @close="clientForm = false"
        @clientFormResponse="formSuccess($event)"
      >
      </client-form>
    </v-navigation-drawer>
    <!-- / Client Form -->
  </div>
</template>
<script>
import ClientForm from "@/components/crm/client/forms/ClientForm";
import ClientContactNumbers from "@/components/crm/client/client_detail/ClientContactNumbers";
import ClientBasicInformation from "@/components/crm/client/client_detail/ClientBasicInformation";
import ClientAssignedUsers from "@/components/crm/client/client_detail/ClientAssignedUsers";
import ClientSocialLink from "@/components/crm/client/client_detail/ClientSocialLinks";
// import ClientActivity from "@/components/crm/client/client_detail/ClientActivity";

export default {
  components: {
    ClientForm,
    ClientContactNumbers,
    ClientAssignedUsers,
    // ClientActivity,
    ClientSocialLink,
    ClientBasicInformation
  },
  props: {
    clientDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // props form
      clientContactNumberForm: false,
      clientAssignedUserForm: false,
      clientSocialLinkForm: false,
      // form
      clientForm: false,
      clientStats: [
        { name: "Opportunities", data: "", amount: 0 },
        { name: "Lead", data: "", amount: 0 },
        { name: "Deal", data: "", amount: 0 },
        { name: "Closed Deals", data: "", amount: 0 },
        { name: "Last Communicated", data: "" },
        { name: "Latest Service Taken", data: "" },
        { name: "Total Communications", data: 2 },
        { name: "Total Sales Process/s", data: 1 },
        { name: "Contact Persons", data: 2 },
        { name: "Total Communications", data: "" }
      ],

      clientEndPoint: "/api/v1/crm/clients/",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition"
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.clientStats[0].data = this.clientDetail.total_opportunities;
      this.clientStats[0].amount =
        this.clientDetail.total_opportunity_amount || 0;
      this.clientStats[1].data = this.clientDetail.total_leads;
      this.clientStats[1].amount = this.clientDetail.total_lead_amount || 0;
      this.clientStats[2].data = this.clientDetail.total_deals;
      this.clientStats[2].amount = this.clientDetail.total_deal_amount || 0;
      this.clientStats[3].data = this.clientDetail.total_closed_deals;
      this.clientStats[3].amount =
        this.clientDetail.total_closed_deal_amount || 0;
      this.clientStats[4].data = this.clientDetail.last_communicated
        ? this.$dayjs(this.clientDetail.last_communicated).format("YYYY-MM-DD")
        : "N/A";
      this.clientStats[5].data =
        this.clientDetail.latest_service_taken_name || "N/A";
      this.clientStats[9].data = this.clientDetail.total_communications;
    },
    formSuccess(updatedClientData) {
      this.clientForm = false;
      this.$emit("clientFormResponse", updatedClientData);
    }
  }
};
</script>
